import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../../shared/render-views-state';

import Table from '../components/table-additional/table';
import SortableOffer from '../components/table-additional/order';
import Search from '../../shared/search/main';
import Filters from '../../shared/filters/main';

import { selectors as rootSelectors } from '../../root';

import PageContainer from '../../shared/page-container/main';
import tabs from '../tabs';

const Main = renderViewsState((props) => {
	return (
		<PageContainer name='List of offers' tabs={tabs}>
			<div className="container__content programs-list">
				<div className="programs-list__filter-position clearfix">
					<Filters {...props} {...props.filters} />
				</div>
				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---search">
						<div className="ui-control-bar__item-position">
							<Search
								form="offersSearchForm"
								autoFocus={true}
								action={props.search}
								initialValues={props.searchInitialValues}
								{...props}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							{props.can('edit') && (
								<Link to="programs/editor/" className="ui-btn ui-btn-primary ui-btn-sign__plus">
									{props.intl('Add offer')}
								</Link>
							)}
							<button className="ui-btn ui-btn-primary" onClick={props.apply}>
								{props.intl('Apply')}
							</button>
							<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
						</div>
					</div>
				</div>
				{ props.switchToOrderMode ? <SortableOffer {...props} /> :  <Table {...props} /> }
			</div>
		</PageContainer>
	);
}, 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		lists: state.root.lists,
		filters: selectors.getFilters(state),
		progressBar: selectors.getProgressBar(state),
		searchInitialValues: selectors.getSearchInitialValues(state),
		switchToOrderMode: selectors.getSwitchToOrderMode(state),
		shouldShowSaveOrderBtn: selectors.getShouldShowSaveOrderBtn(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/additional-list/main.js